import { useState } from "react"
import { useRouter } from "next/router"
import Link from "next/link"

import Input from "components/Input"
import TextArea from "components/TextArea"
import Header from "sections/Header"
import Acrylic from "components/Acrylic"
import client from "client"
import useUser from "user/useUser"

export default function FeedbackPage() {
	const router = useRouter()
	const { data: user } = useUser()

	const [subject, setSubject] = useState<string>("")
	const [message, setMessage] = useState<string>("")

	const submitForm = async (event: any) => {
		event.preventDefault()

		const feedback = { subject, message, profile: user?.id || null }
		await client.from("feedback").insert(feedback)

		setSubject("")
		setMessage("")
		router.push("/")
	}

	return (
		<div className="w-full max-w-6xl mx-auto py-2 px-1">
			<Header />

			<div className="mx-auto flex h-[80vh] w-full flex-col items-center justify-center px-2">
				<Acrylic className="flex flex-col gap-2 rounded-md p-3 w-96">
					<header className="w-full flex flex-col gap-3">
						<h2 className="text-xl font-medium">
							What do you think?
						</h2>
						<p className="leading-snug">
							GradientHub is a project by{" "}
							<Link href="https://thomaseckert.dev">
								<span className="underline underline-offset-2 cursor-pointer">
									Thomas Eckert
								</span>
							</Link>
							.
						</p>
						<p className="leading-snug">
							If you have found a bug or have a feature request,
							please let me know.
						</p>
					</header>

					<form
						className="flex w-full flex-col gap-3"
						onSubmit={submitForm}
					>
						<div className="flex w-full flex-col gap-4 pt-2">
							<Input
								name="title"
								type="text"
								label="Subject"
								value={subject}
								setValue={setSubject}
								required={false}
							/>

							<TextArea
								name="body"
								label="Feedback"
								value={message}
								setValue={setMessage}
								required={true}
							/>
						</div>

						<div className="flex w-full flex-row justify-end">
							<button
								name="submit"
								className="flex flex-row items-center rounded-full py-1 px-2 text-slate-900 transition hover:bg-slate-900 hover:text-white font-medium text-sm"
							>
								Submit
							</button>
						</div>
					</form>
				</Acrylic>
			</div>

			<div
				style={{
					background:
						"radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)",
				}}
				className="fixed -top-[140vh] -right-[100vw] -z-10 h-[200vh] w-[200vw] rotate-12 overflow-clip"
			/>
			<div
				style={{
					background:
						"linear-gradient(to right top, #c02425, #f0cb35)",
				}}
				className="fixed -bottom-[130vh] -left-[70vw] -z-10 h-[200vh] w-[200vw] rotate-12 overflow-clip"
			/>
		</div>
	)
}
